
import { useState } from 'react';
import { Poll } from '@/types/poll';

export const usePollFilters = (allPolls: Poll[], closedPolls: Poll[]) => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [showClosedPolls, setShowClosedPolls] = useState(true);

  const filteredPolls = allPolls.filter(poll => 
    !selectedCategory || poll.category_id === selectedCategory
  );

  const filteredClosedPolls = closedPolls.filter(poll => 
    !selectedCategory || poll.category_id === selectedCategory
  );

  return {
    selectedCategory,
    setSelectedCategory,
    showClosedPolls,
    setShowClosedPolls,
    filteredPolls,
    filteredClosedPolls
  };
};
